export const AI_GENERATE_VERSIONS_FORM = "AIGenerateVersions";

export const MODES = {
	CREATIVES: "CREATIVES",
	CONCEPT: "CONCEPT",
};
